import React, { useEffect, useState } from "react";
import logo from "../../assets/img/login1.png";
import { baseurl } from "../../baseurl";
import axios from "axios";
import Swal from "sweetalert2";

const getModuleIcon = (name = "") => {
  const n = name.toLowerCase();
  if (n.includes("invoice") || n.includes("billing")) return "🧾";
  if (n.includes("estimate") || n.includes("quot"))   return "📋";
  if (n.includes("expense") || n.includes("income"))  return "💳";
  if (n.includes("inventory") || n.includes("stock")) return "📦";
  if (n.includes("product") || n.includes("catalog")) return "🏷️";
  if (n.includes("customer") || n.includes("crm"))    return "👥";
  if (n.includes("report") || n.includes("analytic")) return "📊";
  if (n.includes("gst") || n.includes("tax"))         return "🏛️";
  if (n.includes("payment"))                           return "💰";
  if (n.includes("notification"))                      return "🔔";
  if (n.includes("subscription"))                      return "📅";
  if (n.includes("setting"))                           return "⚙️";
  return "✦";
};

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

@keyframes fo__spin    { to{transform:rotate(360deg)} }
@keyframes fo__floatA  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-18px)} }
@keyframes fo__floatB  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(14px)} }
@keyframes fo__floatC  { 0%,100%{transform:translate(0,0)} 50%{transform:translate(10px,-12px)} }
@keyframes fo__fadeUp  { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
@keyframes fo__pulse   { 0%,100%{box-shadow:0 0 0 0 rgba(10,85,86,0.4)} 70%{box-shadow:0 0 0 9px rgba(10,85,86,0)} }
@keyframes fo__shimmer { 0%{background-position:-400px 0} 100%{background-position:400px 0} }
@keyframes fo__checkPop{ 0%{transform:scale(0)} 60%{transform:scale(1.3)} 100%{transform:scale(1)} }

*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}

.fo__root{
  min-height:100vh;
  font-family:'Inter','Segoe UI',sans-serif;
  background:#eef6f6;
  position:relative;
  overflow-x:hidden;
}

.fo__blob{position:fixed;border-radius:50%;pointer-events:none;z-index:0;}
.fo__blob--1{width:500px;height:500px;top:-170px;left:-170px;background:radial-gradient(circle,rgba(10,85,86,0.15) 0%,transparent 68%);animation:fo__floatA 8s ease-in-out infinite;}
.fo__blob--2{width:440px;height:440px;bottom:-130px;right:-110px;background:radial-gradient(circle,rgba(20,184,166,0.12) 0%,transparent 68%);animation:fo__floatB 10s ease-in-out infinite;}
.fo__blob--3{width:300px;height:300px;top:40%;left:38%;background:radial-gradient(circle,rgba(10,85,86,0.07) 0%,transparent 70%);animation:fo__floatC 12s ease-in-out infinite;}
.fo__blob--4{width:200px;height:200px;top:6%;right:26%;background:radial-gradient(circle,rgba(255,209,102,0.15) 0%,transparent 70%);animation:fo__floatB 9s ease-in-out infinite;}
.fo__grid{position:fixed;inset:0;pointer-events:none;z-index:0;background-image:linear-gradient(rgba(10,85,86,0.03) 1px,transparent 1px),linear-gradient(90deg,rgba(10,85,86,0.03) 1px,transparent 1px);background-size:52px 52px;}

/* ── PAGE ── */
.fo__page{
  position:relative;z-index:1;
  min-height:100vh;
  display:flex;flex-direction:column;align-items:center;
  padding:36px 20px 52px;
  gap:18px;
}

/* ── HERO ── */
.fo__hero{
  width:100%;max-width:680px;
  text-align:center;
  animation:fo__fadeUp 0.6s ease both;
}
.fo__hero-logo{
  width:56px;height:56px;border-radius:18px;overflow:hidden;
  border:3px solid #fff;
  box-shadow:0 6px 20px rgba(10,85,86,0.18);
  margin:0 auto 14px;
}
.fo__hero-logo img{width:100%;height:100%;object-fit:cover;display:block;}
.fo__hero-badge{
  display:inline-flex;align-items:center;gap:7px;
  background:rgba(10,85,86,0.08);border:1px solid rgba(10,85,86,0.20);
  border-radius:50px;padding:6px 16px;
  font-family:'Sora',sans-serif;font-size:10.5px;font-weight:700;
  color:#0a5556;letter-spacing:0.08em;text-transform:uppercase;
  margin-bottom:12px;
}
.fo__hero-dot{width:6px;height:6px;border-radius:50%;background:#0a5556;animation:fo__pulse 2s infinite;}
.fo__hero-title{
  font-family:'Sora',sans-serif;
  font-size:clamp(22px,4vw,34px);font-weight:800;
  color:#062020;letter-spacing:-0.04em;line-height:1.2;
  margin-bottom:10px;
}
.fo__hero-accent{color:#0a5556;position:relative;display:inline-block;}
.fo__hero-accent::after{content:'';position:absolute;bottom:1px;left:0;width:100%;height:3px;background:linear-gradient(90deg,#0a5556,#14b8a6);border-radius:2px;}
.fo__hero-sub{font-size:13.5px;color:#4a7070;line-height:1.72;max-width:500px;margin:0 auto;}

/* ── PROGRESS BAR ── */
.fo__prog{
  width:100%;max-width:680px;
  display:flex;align-items:center;gap:14px;
  background:rgba(255,255,255,0.78);backdrop-filter:blur(16px);
  border:1px solid rgba(10,85,86,0.10);border-radius:14px;
  padding:12px 20px;
  box-shadow:0 2px 12px rgba(10,85,86,0.05);
  animation:fo__fadeUp 0.65s 0.08s ease both;
}
.fo__prog-lbl{font-size:10.5px;font-weight:700;color:#6b8a8a;letter-spacing:0.06em;text-transform:uppercase;white-space:nowrap;}
.fo__prog-track{flex:1;height:6px;border-radius:50px;background:#c8e4e4;overflow:hidden;}
.fo__prog-fill{height:100%;border-radius:50px;background:linear-gradient(90deg,#0a5556,#14b8a6);width:66%;}
.fo__prog-pct{font-family:'Sora',sans-serif;font-size:12px;font-weight:800;color:#0a5556;white-space:nowrap;}

/* ── CARD ── */
.fo__card{
  width:100%;max-width:680px;
  background:rgba(255,255,255,0.92);backdrop-filter:blur(30px);
  border-radius:26px;
  border:1px solid rgba(255,255,255,0.88);
  box-shadow:0 0 0 1px rgba(10,85,86,0.06),0 8px 28px rgba(10,85,86,0.08),0 24px 60px rgba(0,0,0,0.07),inset 0 1px 0 #fff;
  position:relative;overflow:hidden;
  animation:fo__fadeUp 0.7s 0.14s ease both;
}
.fo__card::before{content:'';position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,#0a5556 0%,#14b8a6 55%,#FFD166 100%);border-radius:26px 26px 0 0;}

/* toolbar */
.fo__toolbar{
  display:flex;align-items:center;justify-content:space-between;
  padding:20px 22px 12px;
  border-bottom:1px solid rgba(10,85,86,0.07);
}
.fo__count-pill{
  display:inline-flex;align-items:center;gap:6px;
  font-size:12px;font-weight:600;color:#0a5556;
  background:rgba(10,85,86,0.07);border:1px solid rgba(10,85,86,0.13);
  border-radius:50px;padding:5px 14px;
}
.fo__count-num{font-family:'Sora',sans-serif;font-weight:800;font-size:14px;}
.fo__toggle-all{
  font-size:11.5px;font-weight:700;font-family:'Sora',sans-serif;
  color:#0a5556;background:transparent;
  border:1.5px solid rgba(10,85,86,0.25);border-radius:50px;
  padding:6px 16px;cursor:pointer;
  transition:background 0.18s,color 0.18s,border-color 0.18s;
}
.fo__toggle-all:hover{background:#0a5556;color:#fff;border-color:#0a5556;}

/* ── LIST ── */
.fo__list{
  padding:10px 16px 6px;
  display:flex;flex-direction:column;gap:5px;
  max-height:420px;overflow-y:auto;
  scrollbar-width:thin;
  scrollbar-color:rgba(10,85,86,0.16) transparent;
}
.fo__list::-webkit-scrollbar{width:4px;}
.fo__list::-webkit-scrollbar-thumb{background:rgba(10,85,86,0.16);border-radius:4px;}

/* module row */
.fo__mod{
  display:flex;align-items:center;gap:12px;
  padding:11px 14px;border-radius:12px;
  background:#f6fcfc;border:1.5px solid #d8eeee;
  cursor:pointer;transition:all 0.17s;user-select:none;
  position:relative;
}
.fo__mod:hover{background:#edf8f8;border-color:rgba(10,85,86,0.30);transform:translateX(3px);box-shadow:0 2px 12px rgba(10,85,86,0.07);}
.fo__mod--selected{background:rgba(10,85,86,0.05);border-color:#0a5556;box-shadow:0 0 0 3px rgba(10,85,86,0.07);}
.fo__mod--selected:hover{transform:translateX(3px);}

.fo__mod-chk{position:absolute;opacity:0;pointer-events:none;}

.fo__mod-icon{
  width:34px;height:34px;border-radius:9px;flex-shrink:0;
  display:flex;align-items:center;justify-content:center;font-size:15px;
  background:rgba(10,85,86,0.07);
  transition:background 0.17s,box-shadow 0.17s;
}
.fo__mod--selected .fo__mod-icon{background:linear-gradient(135deg,#0a5556,#14b8a6);box-shadow:0 3px 10px rgba(10,85,86,0.22);}

.fo__mod-body{flex:1;min-width:0;}
.fo__mod-name{font-size:13px;font-weight:700;color:#0a2020;display:flex;align-items:center;gap:7px;flex-wrap:wrap;}
.fo__mod--selected .fo__mod-name{color:#0a5556;}
.fo__mod-desc{font-size:11px;color:#7a9999;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}

.fo__mod-default{
  font-size:8px;font-weight:700;font-family:'Sora',sans-serif;
  letter-spacing:0.06em;text-transform:uppercase;
  background:linear-gradient(135deg,rgba(255,209,102,0.22),rgba(255,209,102,0.10));
  border:1px solid rgba(255,209,102,0.36);color:#9a6400;
  padding:2px 7px;border-radius:50px;flex-shrink:0;
}

.fo__mod-check{
  width:19px;height:19px;border-radius:6px;flex-shrink:0;
  border:2px solid #c8e4e4;background:#fff;
  display:flex;align-items:center;justify-content:center;
  transition:border-color 0.17s,background 0.17s;
}
.fo__mod--selected .fo__mod-check{background:linear-gradient(135deg,#0a5556,#14b8a6);border-color:transparent;animation:fo__checkPop 0.22s ease both;}
.fo__mod-check-tick{color:#fff;font-size:9px;font-weight:900;display:none;}
.fo__mod--selected .fo__mod-check-tick{display:block;}

/* ── INFO TILES (bottom of card) ── */
.fo__info{
  display:grid;grid-template-columns:repeat(3,1fr);gap:8px;
  padding:14px 16px 16px;
  border-top:1px solid rgba(10,85,86,0.07);
}
.fo__info-tile{
  display:flex;align-items:center;gap:9px;
  background:rgba(10,85,86,0.04);border:1px solid rgba(10,85,86,0.08);
  border-radius:11px;padding:10px 12px;
}
.fo__info-icon{width:28px;height:28px;border-radius:8px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:12px;background:linear-gradient(135deg,#0a5556,#14b8a6);box-shadow:0 3px 8px rgba(10,85,86,0.18);}
.fo__info-text{font-size:11px;font-weight:600;color:#2a4a4a;line-height:1.35;}

/* ── CTA ── */
.fo__footer{padding:0 16px 20px;}
.fo__btn{
  width:100%;padding:13px;
  font-size:15px;font-family:'Sora',sans-serif;font-weight:700;
  color:#fff;letter-spacing:0.04em;
  background:linear-gradient(135deg,#0a5556 0%,#0c7172 50%,#14b8a6 100%);
  background-size:200% auto;
  border:none;border-radius:13px;cursor:pointer;
  box-shadow:0 6px 24px rgba(10,85,86,0.32);
  transition:background-position 0.4s,transform 0.15s,box-shadow 0.2s;
  position:relative;overflow:hidden;
}
.fo__btn::after{content:'';position:absolute;inset:0;background:linear-gradient(90deg,transparent,rgba(255,255,255,0.14),transparent);background-size:400px 100%;opacity:0;transition:opacity 0.3s;}
.fo__btn:hover{background-position:right center;transform:translateY(-2px);box-shadow:0 12px 32px rgba(10,85,86,0.40);}
.fo__btn:hover::after{opacity:1;animation:fo__shimmer 1.1s linear infinite;}
.fo__btn:active{transform:translateY(0);}
.fo__btn:disabled{opacity:0.65;cursor:not-allowed;transform:none !important;}
.fo__spin-icon{display:inline-block;width:14px;height:14px;border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;border-radius:50%;animation:fo__spin 0.72s linear infinite;vertical-align:middle;margin-right:8px;}

/* loading */
.fo__loading{min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#eef6f6;gap:16px;}
.fo__loading-spinner{width:40px;height:40px;border:3px solid rgba(10,85,86,0.15);border-top-color:#0a5556;border-radius:50%;animation:fo__spin 0.8s linear infinite;}
.fo__loading-text{font-family:'Sora',sans-serif;font-size:14px;font-weight:600;color:#0a5556;}

@media(max-width:480px){
  .fo__info{grid-template-columns:1fr;}
  .fo__mod-desc{display:none;}
}
`;

function FeaturesOpt() {
  const token = localStorage.getItem("auth_token");

  const [modules, setModules]                 = useState([]);
  const [selectedModules, setSelectedModules] = useState([]);
  const [loading, setLoading]                 = useState(false);
  const [fetching, setFetching]               = useState(true);

  useEffect(() => {
  const fetchInitialData = async () => {
    try {
      // Run both API calls at the same time for better performance
      const [allRes, savedRes] = await Promise.all([
        axios.get(`${baseurl}getAllModules`, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(`${baseurl}getSavedBusinessModules`, {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);

      if (allRes.data.success) {
        setModules(allRes.data.data);
      }

      if (savedRes.data.success) {
        // Map the saved modules to just their IDs for the selectedModules state
        const savedIds = savedRes.data.data.map((m) => m.id);
        
        // If user has saved modules, use those. 
        // Otherwise, fallback to your "Invoice & Billing" default logic.
        if (savedIds.length > 0) {
          setSelectedModules(savedIds);
        } else {
          const defaultModule = allRes.data.data.find((m) => m.name === "Invoice & Billing");
          if (defaultModule) setSelectedModules([defaultModule.id]);
        }
      }
    } catch (error) {
      console.error("❌ Data Fetch Error:", error);
      Swal.fire("Error", "Failed to load features", "error");
    } finally {
      setFetching(false);
    }
  };

  if (token) {
    fetchInitialData();
  }
}, [token]);

  const toggleSelect = (id) => {
    setSelectedModules((prev) =>
      prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    if (selectedModules.length === modules.length) {
      const defaultModule = modules.find((m) => m.name === "Invoice & Billing");
      setSelectedModules(defaultModule ? [defaultModule.id] : []);
    } else {
      setSelectedModules(modules.map((m) => m.id));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) { Swal.fire("Unauthorized", "Please login again", "error"); return; }
    if (selectedModules.length === 0) { Swal.fire("Error", "Select at least one feature", "error"); return; }
    setLoading(true);
    console.log("📤 Sending Module IDs:", selectedModules);
    try {
      const res = await axios.post(
        `${baseurl}saveBusinessModules`,
        { module_ids: selectedModules },
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      if (res.data.success) {
        Swal.fire({ toast: true, position: "top-end", icon: "success", title: "Features enabled successfully", showConfirmButton: false, timer: 2500 });
        setTimeout(() => { window.location.href = "/invoices"; }, 1200);
      }
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Failed to save features", "error");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <>
        <style>{CSS}</style>
        <div className="fo__loading">
          <div className="fo__loading-spinner" />
          <div className="fo__loading-text">Loading features…</div>
        </div>
      </>
    );
  }

  const allSelected = selectedModules.length === modules.length;

  return (
    <>
      <style>{CSS}</style>
      <div className="fo__root">
        <div className="fo__blob fo__blob--1" />
        <div className="fo__blob fo__blob--2" />
        <div className="fo__blob fo__blob--3" />
        <div className="fo__blob fo__blob--4" />
        <div className="fo__grid" />

        <div className="fo__page">

          {/* ── HERO TOP ── */}
          <div className="fo__hero">
            <div className="fo__hero-logo"><img src={logo} alt="logo" /></div>
            <div className="fo__hero-badge">
              <div className="fo__hero-dot" /> Final Step — Step 3 of 3
            </div>
            <h1 className="fo__hero-title">
              Choose your <span className="fo__hero-accent">modules</span>
            </h1>
            <p className="fo__hero-sub">
              Select the features you want active in your dashboard.
              Invoice &amp; Billing is on by default — add anything else you need.
              You can always change this from Settings later.
            </p>
          </div>

          {/* ── PROGRESS ── */}
          <div className="fo__prog">
            <span className="fo__prog-lbl">Setup Progress</span>
            <div className="fo__prog-track"><div className="fo__prog-fill" /></div>
            <span className="fo__prog-pct">Step 3 / 3</span>
          </div>

          {/* ── CARD ── */}
          <div className="fo__card">

            {/* Toolbar */}
            <div className="fo__toolbar">
              <div className="fo__count-pill">
                <span className="fo__count-num">{selectedModules.length}</span>
                &nbsp;of {modules.length} selected
              </div>
              <button type="button" className="fo__toggle-all" onClick={toggleSelectAll}>
                {allSelected ? "Unselect All" : "Select All"}
              </button>
            </div>

            <form onSubmit={handleSubmit}>

              {/* Scrollable module list */}
              <div className="fo__list">
                {modules.map((module) => {
                  const isSelected = selectedModules.includes(module.id);
                  const isDefault  = module.name === "Invoice & Billing";
                  return (
                    <div
                      key={module.id}
                      className={`fo__mod ${isSelected ? "fo__mod--selected" : ""}`}
                      onClick={() => toggleSelect(module.id)}
                    >
                      <input
                        type="checkbox"
                        className="fo__mod-chk"
                        checked={isSelected}
                        onChange={() => toggleSelect(module.id)}
                      />
                      <div className="fo__mod-icon">{getModuleIcon(module.name)}</div>
                      <div className="fo__mod-body">
                        <div className="fo__mod-name">
                          {module.name}
                          {isDefault && <span className="fo__mod-default">Default</span>}
                        </div>
                        <div className="fo__mod-desc">{module.description}</div>
                      </div>
                      <div className="fo__mod-check">
                        <span className="fo__mod-check-tick">✓</span>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Info tiles */}
              <div className="fo__info">
                {[
                  { icon: "✓",  text: "Only pay for what you use" },
                  { icon: "⚡", text: "Instant module activation" },
                  { icon: "🔒", text: "Change anytime in Settings" },
                ].map((t) => (
                  <div className="fo__info-tile" key={t.text}>
                    <div className="fo__info-icon">{t.icon}</div>
                    <span className="fo__info-text">{t.text}</span>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <div className="fo__footer">
                <button type="submit" className="fo__btn" disabled={loading}>
                  {loading
                    ? <><span className="fo__spin-icon" />Saving…</>
                    : "Save & Complete Setup →"
                  }
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeaturesOpt;
